<template>
  <div>
    <oxd-text>
      <a v-if="item" :href="item" target="_blank">Show image</a>
      <span v-else>No image</span>
    </oxd-text>
  </div>
</template>

<script lang="ts">
import {defineComponent, reactive, toRefs} from 'vue';

export default defineComponent({
  name: 'TextAncor',
  props: {
    item: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup() {
    const state = reactive({
      showPhoto: false,
    });

    const onSelectPhoto = () => {
      state.showPhoto = true;
    };

    const onCloseFrame = () => {
      state.showPhoto = false;
    };

    return {
      onSelectPhoto,
      onCloseFrame,
      ...toRefs(state),
    };
  },
});
</script>
